import { orgListApi, orgInfoApi } from '@/api/org/index'

// initial state
const state = {
  orgList: {},
  orgInfo: {
    orgInfo: {}
  }
}

// getters
const getters = {}

// actions
const actions = {
  // 获取公证处列表
  orgListAction ({ commit }, qurey) {
    return new Promise((resolve, reject) => {
      orgListApi(qurey).then(response => {
        if (response.status === '2000') {
          commit('setOrgList', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
    // 获取公证处详情
  orgInfoAction ({ commit }, qurey) {
    return new Promise((resolve, reject) => {
      orgInfoApi(qurey).then(response => {
        if (response.status === '2000') {
          commit('setOrgInfo', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}

// mutations
const mutations = {
  setOrgList (state, orgList) {
    state.orgList = orgList
  },
  setOrgInfo (state, orgInfo) {
    state.orgInfo = orgInfo
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/org/index.js